const omegaSet = {
    init() {
        window.OmegaStats && window.OmegaStats.setConfig({
            project: {
                id: window.PROJECT_ID,
            },
        });
    },
};

export default omegaSet;
